import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { LangConstant } from "const";
import { SERVICE_ID } from "const/system.const";

const Datatable = ({ conferences, pagination, onChangePage, onViewDetails, onViewConfig }) => {
  const { t: getLabel } = useTranslation();
  const classes = useStyles();
  return (
    <Fragment>
      <TableContainer sx={{ my: 4, height: 500 }}>
        <Table stickyHeader sx={{ minWidth: 650 }} className={classes.boxTable}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "30%", fontWeight: "bold" }}>{getLabel("TXT_APPLICATION_NAME")}</TableCell>
              <TableCell sx={{ width: "45%", fontWeight: "bold" }}>{getLabel("TXT_DESCRIPTION")}</TableCell>
              <TableCell sx={{ width: "15%", fontWeight: "bold" }}>{getLabel("TXT_ADMINISTRATOR")}</TableCell>
              <TableCell sx={{ width: "15%", fontWeight: "bold" }}>{getLabel("TXT_ACTION")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conferences.length > 0 ? (
              conferences.map((app, index) => {
                const isConferenceService = app.serviceId === SERVICE_ID.conference;

                return (
                  <TableRow key={index}>
                    <TableCell className={classes.name} title={app.name}>
                      {app.name}
                    </TableCell>
                    <TableCell className={classes.name} title={app.description}>
                      {app.description}
                    </TableCell>

                    <TableCell className={classes.name}>
                      {isConferenceService && (
                        <span
                          className={classes.addButton}
                          title={app.adminAccountIds?.length || getLabel(LangConstant.L_ADD_BUTTON)}
                          onClick={() => onViewDetails(app)}
                        >
                          {getLabel("TXT_VIEW_DETAIL")}
                        </span>
                      )}
                    </TableCell>

                    <TableCell className={classes.name}>
                      {isConferenceService && (
                        <span className={classes.addButton} onClick={() => onViewConfig(app)}>
                          {getLabel("TXT_CONFIG_APP")}
                        </span>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <small>
                    <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                  </small>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination.total > 1 && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", margin: "24px 0" }}>
          <Pagination
            count={pagination.total}
            onChange={onChangePage}
            page={pagination.current}
            className={classes.pagination}
            color="primary"
            variant="outlined"
            shape="rounded"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Fragment>
  );
};

export default Datatable;

const useStyles = makeStyles(() => ({
  pagination: {
    display: "flex",
    justifyContent: "center",
  },

  boxTable: {
    whiteSpace: "nowrap",
    tableLayout: "fixed",
  },

  name: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  addButton: {
    color: "#007BFF", // Màu xanh sáng hơn
    cursor: "pointer",
    textDecoration: "none", // Bỏ gạch chân mặc định
    "&:hover": {
      textDecoration: "underline", // Chỉ hiển thị gạch chân khi hover
      color: "#0056b3", // Màu xanh đậm hơn khi hover
    },
  },
}));
